
<app-button-close-dialog></app-button-close-dialog>
<h2 mat-dialog-title>Acción realizada :: <strong>Crear</strong></h2>

<br>
<mat-dialog-content>
  <ngx-spinner
    [zIndex]="100"
    name="spNota"
    bdColor="rgba(255,255,255,0.8)"
    size="default"
    color=" var(--primary-color)"
    type="ball-atom"
    [fullScreen]="false"
  >
  </ngx-spinner>
  <form [formGroup]="form">
    <div class="row">
      <ngx-editor-menu [editor]="editor"> </ngx-editor-menu>
      <ngx-editor
        [editor]="editor"
        formControlName="Descripcion"
        [placeholder]="'Escriba aqui...'"
      ></ngx-editor>
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">

  <app-button-cancel-dialog></app-button-cancel-dialog>
  <app-button-add  [disabled]="!form.valid" (click)="onSubmit()"></app-button-add>
</mat-dialog-actions>

